import React from 'react';
import { createRoot } from 'react-dom/client';
import Providers from './Providers';
import App from './App';
import registerServiceWorker, { unregister } from './registerServiceWorker';
import './index.css';
import './page/workQueue2/css/workqueue.scss';
import './page/workQueue2/css/referee-doctor-list.scss';
import * as Sentry from '@sentry/react';

const { hostname } = window.location;
let env = false;
if (hostname.indexOf('uat.') > -1) env = 'uat';
if (hostname.indexOf('test.') > -1) env = 'test';
if (hostname.indexOf('funeralmanager.com.au') > -1) env = 'live';
if (env) {
    Sentry.init({
        dsn: 'https://2f7e01ce89777d6722570f0db2c405c7@o4509227928911872.ingest.de.sentry.io/4509279641993296',
        environment: env,
        autoSessionTracking: true,
        sendDefaultPii: true,
        release: localStorage.getItem('commit_ref')
    });
}

const root = createRoot(document.getElementById('root'));
root.render(
    <Providers>
        <App />
    </Providers>
);

if (1 === 2) registerServiceWorker();
else unregister();
